/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */

const ANONYMOUS_COMPARISONS = {
  comparison: [{
    label: 'is',
    value: 'false'
  }, {
    label: 'is',
    value: 'true'
  }]
};
const BOOLEAN_COMPARISONS = {
  comparison: [{
    label: 'is true',
    value: 'true'
  }, {
    label: 'is false',
    value: 'false'
  }, {
    label: 'is unknown',
    value: 'unknown'
  }, {
    label: 'has any value',
    value: 'known'
  }]
};
const STRING_COMPARISONS = {
  comparison: [{
    label: 'is',
    value: 'eq'
  }, {
    label: 'is not',
    value: 'ne'
  }, {
    label: 'starts with',
    value: 'starts_with'
  }, {
    label: 'ends with',
    value: 'ends_with',
    selected: false
  }, {
    label: 'contains',
    value: 'contains'
  }, {
    label: 'contains exact word',
    value: 'contains_exact_word'
  }, {
    label: 'does not contain',
    value: 'not_contains'
  }, {
    label: 'is unknown',
    value: 'unknown'
  }, {
    label: 'has any value',
    value: 'known'
  }]
};
const DATE_COMPARISONS = {
  comparison: [{
    label: 'more than',
    value: 'lt:relative',
    type: 'relative'
  }, {
    label: 'exactly',
    value: 'eq:relative',
    type: 'relative'
  }, {
    label: 'less than',
    value: 'gt:relative',
    type: 'relative'
  }, {
    label: 'after',
    value: 'gt:absolute',
    type: 'absolute'
  }, {
    label: 'on',
    value: 'eq:absolute',
    type: 'absolute'
  }, {
    label: 'before',
    value: 'lt:absolute',
    type: 'absolute'
  }, {
    label: 'is unknown',
    value: 'unknown'
  }, {
    label: 'has any value',
    value: 'known'
  }],
  months: [{
    label: 'Jan',
    days: 31,
    value: 1
  }, {
    label: 'Feb',
    days: 29,
    value: 2
  }, {
    label: 'Mar',
    days: 31,
    value: 3
  }, {
    label: 'Apr',
    days: 30,
    value: 4
  }, {
    label: 'May',
    days: 31,
    value: 5
  }, {
    label: 'Jun',
    days: 30,
    value: 6
  }, {
    label: 'Jul',
    days: 31,
    value: 7
  }, {
    label: 'Aug',
    days: 31,
    value: 8
  }, {
    label: 'Sep',
    days: 30,
    value: 9
  }, {
    label: 'Oct',
    days: 31,
    value: 10
  }, {
    label: 'Nov',
    days: 30,
    value: 11
  }, {
    label: 'Dec',
    days: 31,
    value: 12
  }]
};
const DATETIME_COMPARISONS = {
  comparison: [{
    label: 'more than',
    value: 'lt:relative',
    type: 'relative',
    direction: 'past'
  }, {
    label: 'less than',
    value: 'gt:relative',
    type: 'relative',
    direction: 'past'
  }, {
    label: 'less than',
    value: 'lt:relative',
    type: 'relative',
    direction: 'future'
  }, {
    label: 'more than',
    value: 'gt:relative',
    type: 'relative',
    direction: 'future'
  }]
};
const NUMERIC_COMPARISONS = {
  comparison: [{
    label: 'greater than',
    value: 'gt'
  }, {
    label: 'less than',
    value: 'lt'
  }, {
    label: 'is',
    value: 'eq'
  }, {
    label: 'is not',
    value: 'ne'
  }, {
    label: 'is unknown',
    value: 'unknown'
  }, {
    label: 'has any value',
    value: 'known'
  }]
};
const SELECT_COMPARISONS = {
  comparison: [{
    label: 'is',
    value: 'in'
  }, {
    label: 'is not',
    value: 'nin'
  }]
};
const NUMERIC_SELECT_COMPARISONS = {
  comparison: [{
    label: 'is',
    value: 'eq'
  }, {
    label: 'greater than',
    value: 'gt'
  }, {
    label: 'less than',
    value: 'lt'
  }]
};
const OPTIONAL_SELECT_COMPARISONS = {
  comparison: [{
    label: 'is',
    value: 'eq'
  }, {
    label: 'is not',
    value: 'ne'
  }, {
    label: 'is unknown',
    value: 'unknown'
  }, {
    label: 'has any value',
    value: 'known'
  }]
};
const ATTRIBUTE_OPTION_SELECT_COMPARISONS = {
  comparison: [{
    label: 'is',
    value: 'eq'
  }, {
    label: 'is not',
    value: 'ne'
  }]
};
const ATTRIBUTE_OPTION_SELECT_EXTENDED_COMPARISONS = {
  comparison: [{
    label: 'is',
    value: 'eq'
  }, {
    label: 'is not',
    value: 'ne'
  }, {
    label: 'is unknown',
    value: 'unknown'
  }, {
    label: 'has any value',
    value: 'known'
  }]
};
const URL_VISIT_COMPARISONS = {
  comparison: [{
    label: 'is',
    value: 'eq'
  }, {
    label: 'greater than',
    value: 'gt'
  }, {
    label: 'less than',
    value: 'lt'
  }]
};
const OVER_MESSAGING_PROTECTION_COMPARISONS = {
  comparison: [{
    label: 'is true',
    value: 'true'
  }, {
    label: 'is false',
    value: 'false'
  }]
};
const CONTENT_EVENT_COMPARISONS = {
  comparison: []
};
const OFFICE_HOURS_SCHEDULE_COMPARISONS = {
  comparison: [{
    label: 'During',
    value: 'in'
  }, {
    label: 'Outside',
    value: 'nin'
  }]
};
const SURVEY_DROPDOWN_QUESTION_COMPARISONS = {
  comparison: [{
    label: 'is',
    value: 'eq'
  }, {
    label: 'is not',
    value: 'ne'
  }]
};
const TEAM_CAPACITY_COMPARISONS = {
  comparison: [{
    label: 'has capacity',
    value: 'contains'
  }, {
    label: 'no capacity',
    value: 'not_contains'
  }]
};
const COMPANY_ASSOCIATION_COMPARISONS = {
  comparison: [{
    label: 'is',
    value: 'eq'
  }, {
    label: 'is not',
    value: 'ne'
  }]
};
export default {
  anonymous: ANONYMOUS_COMPARISONS,
  boolean: BOOLEAN_COMPARISONS,
  date: DATE_COMPARISONS,
  datetime: DATETIME_COMPARISONS,
  string: STRING_COMPARISONS,
  numeric: NUMERIC_COMPARISONS,
  select: SELECT_COMPARISONS,
  numericSelect: NUMERIC_SELECT_COMPARISONS,
  optionalSelect: OPTIONAL_SELECT_COMPARISONS,
  attributeOptionSelect: ATTRIBUTE_OPTION_SELECT_COMPARISONS,
  attributeOptionSelectExtended: ATTRIBUTE_OPTION_SELECT_EXTENDED_COMPARISONS,
  urlVisit: URL_VISIT_COMPARISONS,
  overMessagingProtection: OVER_MESSAGING_PROTECTION_COMPARISONS,
  contentEvent: CONTENT_EVENT_COMPARISONS,
  officeHoursSchedule: OFFICE_HOURS_SCHEDULE_COMPARISONS,
  surveyDropdownQuestion: SURVEY_DROPDOWN_QUESTION_COMPARISONS,
  teamCapacity: TEAM_CAPACITY_COMPARISONS,
  plan: OPTIONAL_SELECT_COMPARISONS,
  companyAssociation: COMPANY_ASSOCIATION_COMPARISONS
};